import { render } from "./view-stock-transfer.vue?vue&type=template&id=4de4e020"
import script from "./view-stock-transfer.vue?vue&type=script&lang=js"
export * from "./view-stock-transfer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__